// extracted by mini-css-extract-plugin
export default {"container":"style_container__wgYxh","title":"style_title__G804J","p":"style_p__M9xgK","btn":"style_btn__gDSd0"};